export default __webpack_public_path__ + "static/media/pic1.c1bfcbb0.jpg";